export const responsiveOptions = [
  {
    breakpoint: "1024px",
    numVisible: 2,
    numScroll: 1,
  },
  {
    breakpoint: "768px",
    numVisible: 1,
    numScroll: 1,
  },
];

export const responsiveOptionsMain = [
  {
    breakpoint: "768px",
    numVisible: 1,
    numScroll: 1,
  },
];
